import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { useIsMounted } from "usehooks-ts";
import { appParamState } from "../../atoms";
import { GLOBAL_CONST } from "../../constants";
import Onboarding from "./Onboarding";
import Redeem from "./Redeem";

function ShellMain() {
  const [appParam, setAppParam] = useRecoilState(appParamState);
  const isMounted = useIsMounted();

  // Determine the view height so carousel slides can be set correctly. Mostly for Safari on mobile.
  useEffect(() => {
    if (!GLOBAL_CONST.ACCESS_TOKEN) {
      throw new Error("Shell rewards - Unauthenticated (no access token exists)");
    }
  }, [isMounted, setAppParam]);

  // Actually pre-render both onboarding and redeem on the page, with one hidden. Better webview experience preloading the elements.
  const showRedeem = appParam.flow === "redeem";
  return (
    <>
      <span style={{ display: showRedeem ? "none" : "block", height: "100vh" }}>
        <Onboarding />
      </span>
      <span style={{ display: showRedeem ? "block" : "none", height: "100vh" }}>
        <Redeem />
      </span>
    </>
  );
}

export default ShellMain;
